import React from 'react';
import './BusinessList.css';
import Business from '../Business/Business.js';

class BusinessList extends React.Component {
    render() {
        return (
            <section className='main-business__container'>
                {
                    this.props.business
                        .map(option => {
                            return <Business business={option}/>;
                        })
                }
            </section>
        )
    }
}

export default BusinessList;